import { render } from "./currency-page.vue?vue&type=template&id=46e1b7e7&ts=true"
import script from "./currency-page.ts?vue&type=script&lang=ts"
export * from "./currency-page.ts?vue&type=script&lang=ts"

import "./currency-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__